import { Link } from 'react-router-dom';
import MailOutlineIcon from '@mui/icons-material/MailOutlined';
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import CookieOutlinedIcon from '@mui/icons-material/CookieOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import logo from '../assets/Logo_Staisch_innovative_Elektrotechnik.png';
import digelheatPartner from '../assets/digelheat-partner.png';
import toast from 'react-hot-toast';
import * as CookieConsent from 'vanilla-cookieconsent';

const legalLinks = [
  { to: '/impressum', label: 'Impressum', icon: GavelOutlinedIcon },
  { to: '/datenschutz', label: 'Datenschutz', icon: PolicyOutlinedIcon }
];

export const Footer = () => {
  const year = new Date().getFullYear();
  const address = 'Freiherr-vom-Stein-Straße 14, 72654 Neckartenzlingen';
  const phone = '01575 8166291';
  const email = 'info@staisch-elektrotechnik.de';

  const copyToClipboard = async (label: string, value: string) => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      toast.success(`${label} kopiert`);
    } catch (error) {
      toast.error('Kopieren fehlgeschlagen.');
    }
  };

  return (
    <footer className="site-footer">
      <div className="container footer__grid">
        <div className="footer__brand">
          <Link className="brand" to="/" aria-label="Zur Startseite">
            <img src={logo} alt="Staisch Innovative Elektrotechnik" className="brand__logo brand__logo--footer" />
          </Link>
          <p>
            Staisch Innovative Elektrotechnik steht für maßgeschneiderte Lösungen in der
            Elektro- und Gebäudetechnik – zuverlässig, präzise und
            zukunftsorientiert.
          </p>
        </div>
        <div>
          <h4>Kontakt</h4>
          <ul className="footer__links footer__links--icons">
            <li>
              <PhoneInTalkOutlinedIcon className="footer__icon" fontSize="small" aria-hidden="true" />
              <button
                className="footer__copy footer__copy--inline"
                type="button"
                onClick={() => copyToClipboard('Telefonnummer', phone)}
                aria-label={`Telefonnummer kopieren: ${phone}`}
              >
                <span className="footer__copy-text">{phone}</span>
                <ContentCopyOutlinedIcon className="footer__copy-icon" fontSize="small" aria-hidden="true" />
              </button>
            </li>
            <li>
              <MailOutlineIcon className="footer__icon" fontSize="small" aria-hidden="true" />
              <button
                className="footer__copy footer__copy--inline"
                type="button"
                onClick={() => copyToClipboard('E-Mail-Adresse', email)}
                aria-label={`E-Mail-Adresse kopieren: ${email}`}
              >
                <span className="footer__copy-text">{email}</span>
                <ContentCopyOutlinedIcon className="footer__copy-icon" fontSize="small" aria-hidden="true" />
              </button>
            </li>
            <li>
              <PlaceOutlinedIcon className="footer__icon" fontSize="small" aria-hidden="true" />
              <button
                className="footer__copy footer__copy--block"
                type="button"
                onClick={() => copyToClipboard('Adresse', address)}
                aria-label={`Adresse kopieren: ${address}`}
              >
                <span className="footer__copy-text">
                  <span className="footer__copy-line">Freiherr-vom-Stein-Straße 14</span>
                  <span className="footer__copy-line">72654 Neckartenzlingen</span>
                </span>
                <ContentCopyOutlinedIcon className="footer__copy-icon" fontSize="small" aria-hidden="true" />
              </button>
            </li>
          </ul>
        </div>
        <div>
          <h4>Rechtliches</h4>
          <ul className="footer__links footer__links--icons">
            {legalLinks.map((item) => (
              <li key={item.to}>
                <item.icon className="footer__icon" fontSize="small" aria-hidden="true" />
                <Link to={item.to}>{item.label}</Link>
              </li>
            ))}
            <li>
              <CookieOutlinedIcon className="footer__icon" fontSize="small" aria-hidden="true" />
              <button
                type="button"
                className="footer__link-button"
                onClick={() => CookieConsent.showPreferences()}
                aria-label="Cookie-Einstellungen öffnen"
              >
                Cookie-Einstellungen
              </button>
            </li>
          </ul>
        </div>
        <div className="footer__partner">
          <h4>Partner</h4>
          <a
            className="footer__partner-card"
            href="https://www.digel-heat.de"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Digelheat Infrarotheizungen – zertifizierter Partner"
          >
            <img
              src={digelheatPartner}
              alt="Digelheat Infrarotheizungen – zertifizierter Partner"
              className="footer__partner-logo"
              loading="lazy"
            />
            <span className="footer__partner-label">Zertifizierter Partner für Infrarotheizungen</span>
          </a>
        </div>
      </div>
      <div className="container footer__bottom">
        <p>&copy; {year} Staisch Innovative Elektrotechnik. Alle Rechte vorbehalten.</p>
        <a href="#top" className="footer__to-top">
          Nach oben <ArrowUpwardIcon className="footer__icon footer__icon--inline" fontSize="small" aria-hidden="true" />
        </a>
      </div>
    </footer>
  );
};
